import * as Sentry from '@sentry/browser'
import { Module, ModuleAccessControl } from '../../auth/types'
import { checkSyncPermissions } from '../../shared/utils/syncUtil'
import { getCostCenterGroups, getCostCenters } from './api'
import {
  clearCostCenterGroups,
  clearCostCenters,
  overrideCostCenterGroups,
  overrideCostCenters,
} from './db/costCenters'

const syncCostCenter = async (
  modules: Array<ModuleAccessControl>
): Promise<void> => {
  try {
    if (!checkSyncPermissions(modules, Module.timeTacking)) {
      return
    }

    const costCenterGroups = await getCostCenterGroups()
    await overrideCostCenterGroups(costCenterGroups)

    const costCenters = await getCostCenters()
    await overrideCostCenters(costCenters)
  } catch (error: any) {
    if (error.response?.status === 401) {
      await clearCostCenterGroups()
      await clearCostCenters()
    } else {
      Sentry.captureException(error)
    }
  }
}

export { syncCostCenter }
